import messageResource from '../../../messageResource'
import {UserManagementConstants} from "../../../constants"
import View from '../../../View'
import ItemsFilter, {createItemObject, createDelimiterObject} from '../components/itemsFilter/ItemsFilter'

const ManagementFilterValues = UserManagementConstants.ManagementFilter

class ManagementFilter extends View {
    constructor({
        onChange = () => {},
    }) {
        super()

        this.onChange = onChange

        this.state = {
            selectedValue: null
        }

        this.onStateChanged(() => {
            this.itemsFitler.setState({
                selectedValue: this.state.selectedValue
            })
        })
    }

    afterRender() {
        const items = [
            createItemObject(
                ManagementFilterValues.ALL,
                messageResource.getEscapedMessage('userlist.management.filter.all')
            ),
            createDelimiterObject(),
            ... this._getPermissionsItems(),
            createDelimiterObject(),
            ... this._getTeamItems(),
            createDelimiterObject(),
            ... this._getScopeOfWorkItems()
        ]

        this.itemsFitler = new ItemsFilter({
            items,
            defaultValue: ManagementFilterValues.ALL,
            onChange: this._handleChangeItem,
            additionalListClass: 'userlist_managementFilter_list',
            additionalFilterClass: 'greyBackground',
        }).init(this.$containerEl)
    }

    _getPermissionsItems() {
        return [
            createItemObject(
                ManagementFilterValues.ALL_PERMISSIONS,
                messageResource.getEscapedMessage('userlist.management.filter.all_permissions')
            ),
            createItemObject(
                ManagementFilterValues.NO_PERMISSIONS,
                messageResource.getEscapedMessage('userlist.management.filter.no_permissions')
            ),
        ]
    }

    _getTeamItems() {
        return [
            createItemObject(
                ManagementFilterValues.ALL_TEAM,
                messageResource.getEscapedMessage('userlist.management.filter.all_team'),
            ),
            createItemObject(
                ManagementFilterValues.NO_TEAM,
                messageResource.getEscapedMessage('userlist.management.filter.no_team')
            ),
            createItemObject(
                ManagementFilterValues.NO_ACCESS_TO_TEAM,
                messageResource.getEscapedMessage('userlist.management.filter.no_access_to_team')
            ),
        ]
    }

    _getScopeOfWorkItems() {
        return [
            createItemObject(
                ManagementFilterValues.ALL_SCOPE,
                messageResource.getEscapedMessage('userlist.management.filter.all_scope'),
            ),
            createItemObject(
                ManagementFilterValues.NO_SCOPE,
                messageResource.getEscapedMessage('userlist.management.filter.no_scope')
            ),
            createItemObject(
                ManagementFilterValues.NO_ACCESS_TO_SCOPE,
                messageResource.getEscapedMessage('userlist.management.filter.no_access_to_scope')
            ),
        ]
    }

    _handleChangeItem = (value) => {
        this.itemsFitler.setState({
            selectedValue: value,
        })
        this.onChange(value)
    }
}

export default ManagementFilter



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/ManagementFilter.js